import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const InternalILLList = Loadable(
  lazy(() => import("features/internalILL/components/List")),
);

const routes = {
  path: "internalILL",
  children: [{ path: "", element: <InternalILLList /> }],
};

export default routes;
